import { render, staticRenderFns } from "./PasswordTradeModify.vue?vue&type=template&id=0b50d135&scoped=true&"
import script from "./PasswordTradeModify.vue?vue&type=script&lang=ts&"
export * from "./PasswordTradeModify.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordTradeModify.vue?vue&type=style&index=0&id=0b50d135&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50d135",
  null
  
)

export default component.exports